﻿//src/desktop/ui/diagrams/repeaterdiagram.js
import global from '../../../../../../shared/utils/global.js';
import { addLeadingZero } from '../../../../../../shared/utils/general.js';
import { formatTime } from '../../../../../../shared/utils/timeformats.js';
import { getRepeaterHistoryData, getSignalBoosterHistoryData } from './handlerepeaterdata.js';
import { fetchSignalBooster } from './repeaters.api.js';
import { openLocationSensorReport } from '../reports/sensorchartreport.js';
import { openGeneralInfoForm } from '../../../../generalinfo/views/generalinfoview.js';
import { createDiagramView, createTrailerHeader } from '../sensors/unitdiagrams.js';
import { createNotificationButtons } from '../../../../../../shared/components/buttons.js';



import { hideLoading, showLoading } from '../../../../../../shared/components/modal.js';
export const createRepeaterDiagram = async (unit) => {
  unit = global.selectedUnit;
  await displayDiagram(unit);
};

async function displayDiagram(unit) {

  const diagram = document.getElementById('rightpane');
  while (diagram.hasChildNodes()) {
    diagram.removeChild(diagram.lastChild);
  }
  const diagramFragment = document.createDocumentFragment();

  let diagramDiv = document.createElement('div');
  diagramDiv.id = `repeaterdiagram`;
  diagramDiv.className = 'unitdiagram';

  diagramFragment.appendChild(diagramDiv);
  diagram.appendChild(diagramFragment);

  const repeaterDiagramButtons = createRepeaterDiagramButtons(unit);
  diagramDiv.appendChild(repeaterDiagramButtons);

  const repeaterDiagramUnitFrame = unit.wheelSensors && unit.wheelSensors.length ? await createDiagramWheelSensorsUnitFrame(unit) : createDiagramRepeatersOnlyUnitFrame(unit);
  diagramDiv.appendChild(repeaterDiagramUnitFrame);
}

function createDiagramRepeatersOnlyUnitFrame(unit) {

  const repeaterDiagramUnitFrame = document.createElement('div');

  repeaterDiagramUnitFrame.appendChild(createDiagramRepeatersOnlyUnitBox(unit));

  if (unit.type != 'trailer') {
    repeaterDiagramUnitFrame.appendChild(createGatewayElements(unit));
  }

  return repeaterDiagramUnitFrame;
}

function createDiagramRepeatersOnlyUnitBox(unit) {
  const repeaterDiagramUnitBox = document.createElement('div');

  // Check for valid axle data or repeaters
  const axleDataSource = unit?.axleData || unit?.repeaters;

  if (!axleDataSource) {
    console.warn("No axle data or repeaters found for unit.");
    return repeaterDiagramUnitBox; // Return empty container
  }

  if (unit?.axleData) {
    for (let a = 0; a < unit.axles; a++) {
      const unitBoxAxle = createRepeatersOnlyUnitBoxAxle(unit, axleDataSource, a);
      repeaterDiagramUnitBox.appendChild(unitBoxAxle);
    }
  }

  if (unit?.repeaters) {
    for (let a = 0; a < unit.axles; a++) {
      const unitBox = axleDataSource[0].location.slice(-1);
      const unitBoxAxle = createUnitBoxAxle(unitBox, unit, axleDataSource, a + +1);
      repeaterDiagramUnitBox.appendChild(unitBoxAxle);
    }
  }

  return repeaterDiagramUnitBox;
}


function createRepeatersOnlyUnitBoxAxle(unit, axles, axle) {

  const unitBoxAxle = document.createElement('div');
  unitBoxAxle.className = 'diagramaxle';

  const axleRepeaterLeft = axles[axle].left;
  if (axleRepeaterLeft) {
    const repeaterLeft = createSensorElement(unit, axleRepeaterLeft);
    unitBoxAxle.appendChild(repeaterLeft);
  }

  const axleRepeaterRight = axles[axle].right;
  if (axleRepeaterRight) {
    const repeaterRight = createSensorElement(unit, axleRepeaterRight);
    unitBoxAxle.appendChild(repeaterRight);
  }

  return unitBoxAxle;
}

async function loadBoosterData(unit, boosterIds) {
  const promises = boosterIds.map(id => fetchSignalBooster(unit.customerId, id));
  const boosters = await Promise.all(promises);
  return boosters.filter(b => b);   // remove nulls
}

async function createDiagramWheelSensorsUnitFrame(unit) {

  const repeaterDiagramUnitFrame = document.createElement('div');

  //let unitBoxes = [...new Set(Object.keys(unit.wheelSensors).map(item => unit.wheelSensors[item].wheelId.slice(-1)))].sort();
  for (let ub = 0; ub < unit.unitConfig.length; ub++) {
    repeaterDiagramUnitFrame.appendChild(await createDiagramUnitBox(unit, unit.unitConfig[ub].unitNumber));
  }

  if (unit.type != 'trailer') {
    repeaterDiagramUnitFrame.appendChild(createGatewayElements(unit));
  }

  return repeaterDiagramUnitFrame;
}

function createGatewayElements(unit) {

  const gatewayElements = document.createElement('div');
  gatewayElements.className = 'diagramaxle';

  gatewayElements.appendChild(createGatewayElement(unit));
  gatewayElements.appendChild(createSinkElement(unit));

  return gatewayElements;
}

function createGatewayElement(unit) {

  const gateway = document.createElement('div');
  gateway.className = 'gateway';
  gateway.appendChild(createGatewayTopElement());
  gateway.appendChild(createGatewayInfoElement(unit));
  gateway.appendChild(createGatewayBottomElement());

  return gateway;
}

function createSinkElement(unit) {

  const sink = document.createElement('div');
  sink.className = 'sink';

  //sink.appendChild(createSensorTopElement());
  sink.appendChild(createSyncSensorValues(unit));
  //sink.appendChild(createSensorBottomElement());

  sink.onclick = function (e) {
    e.stopImmediatePropagation();
    //openRepeaterContextMenu(unit, repeater);
    openGeneralInfoForm('sink', unit, {});
  };

  return sink;
}

function createSyncSensorValues(unit) {

  const sensorValues = document.createElement('div');
  sensorValues.className = 'sinkvalues';

  sensorValues.appendChild(createSinkIdElement(unit?.sinkId || '--'));
  //sensorValues.appendChild(createSyncSignalStrengthElement(unit?.sinkPowerSupplyVoltage || '--'));
  sensorValues.appendChild(createSyncVoltageElement(unit?.sinkVoltage || '--'));

  return sensorValues;
}

function createSinkIdElement(sinkId) {

  const sinkIdDiv = document.createElement('div');
  let sensorValuesClasses = ['repeatersensorvaluesdefault'];
  //if (axleSensor.signalStrengthLabelColour === "blue")
  //    sensorValuesClasses = ['repeatersensorvaluesdefault', 'blue'];

  sinkIdDiv.classList.add(...sensorValuesClasses);
  sinkIdDiv.innerText = sinkId;

  return sinkIdDiv;
}

function createSyncSignalStrengthElement(sinkPowerSupplyVoltage) {

  const signalStrength = document.createElement('div');
  let sensorValuesClasses = ['repeatersensorvaluesdefault'];
  //if (axleSensor.signalStrengthLabelColour === "blue")
  //    sensorValuesClasses = ['repeatersensorvaluesdefault', 'blue'];

  signalStrength.classList.add(...sensorValuesClasses);
  signalStrength.innerText = `${sinkPowerSupplyVoltage} V`;

  return signalStrength;
}

function createSyncVoltageElement(sinkVoltage) {

  const sensorVoltage = document.createElement('div');
  let sensorValuesClasses = ['repeatersensorvaluesdefault'];
  //if (axleSensor.voltageLabelColour === "yellow")
  //    sensorValuesClasses = ['repeatersensorvaluesdefault', 'yellow'];
  //const voltage = Math.round(axleSensor.currentVoltage * 1000) / 1000;

  sensorVoltage.classList.add(...sensorValuesClasses);
  sensorVoltage.innerText = `${sinkVoltage} V`;

  return sensorVoltage;
}

function createGatewayTopElement() {

  const gatewayTop = document.createElement('div');
  gatewayTop.className = 'gatewaytop';
  const gatewayTopLeft = document.createElement('div');
  gatewayTopLeft.className = 'gatewaytopleft';
  const gatewayTopRight = document.createElement('div');
  gatewayTopRight.className = 'gatewaytopright';
  gatewayTop.appendChild(gatewayTopLeft);
  gatewayTop.appendChild(gatewayTopRight);

  return gatewayTop;
}

function createGatewayBottomElement() {

  const gatewayBottom = document.createElement('div');
  gatewayBottom.className = 'gatewaybottom';

  return gatewayBottom;
}

function createGatewayInfoElement(unit) {

  const gatewayInfo = document.createElement('div');
  gatewayInfo.className = 'gatewayinfo';

  gatewayInfo.appendChild(createGatewayInfo(unit.imei));
  gatewayInfo.appendChild(createGatewayInfo(unit.simCardNumber));
  gatewayInfo.appendChild(createGatewaySignalStrengthElement(unit.gatewayPowerSupplyVoltage));
  gatewayInfo.appendChild(createBatteryVoltageElement(unit.gatewayBatteryVoltage));

  gatewayInfo.onclick = function (e) {
    e.stopImmediatePropagation();
    //openRepeaterContextMenu(unit, repeater);
    openGeneralInfoForm('gateway', unit, {});
  };

  return gatewayInfo;
}

function createGatewayInfo(info) {

  const deviceInfo = document.createElement('div');
  let sensorValuesClasses = ['gatewayvaluesdefault'];

  deviceInfo.classList.add(...sensorValuesClasses);
  deviceInfo.innerText = info;

  return deviceInfo;
}

function createGatewaySignalStrengthElement(signalStrengthValue) {

  const signalStrength = document.createElement('div');
  let sensorValuesClasses = ['gatewayvaluesdefault'];

  signalStrength.classList.add(...sensorValuesClasses);
  signalStrength.innerText = `${signalStrengthValue} V`;

  return signalStrength;
}

function createBatteryVoltageElement(voltage) {

  const batteryVoltage = document.createElement('div');
  let sensorValuesClasses = ['gatewayvaluesdefault'];

  batteryVoltage.classList.add(...sensorValuesClasses);
  batteryVoltage.innerText = `${voltage} V`;

  return batteryVoltage;
}

async function createDiagramUnitBox(unit, unitBox) {

  // --- MAIN CONTAINER FOR THIS UNIT/TRAILER ---
  const repeaterDiagramUnitBox = document.createElement('div');

  // --- TRAILER HEADER (if applicable) ---
  const linkedtrailer = unit.trailers?.find(t => t.trailerNumber === unitBox);
  if (unitBox !== 0 && linkedtrailer) {
    repeaterDiagramUnitBox.appendChild(
      createTrailerHeader('r', linkedtrailer.name)
    );
  }

  // ==========================================================
  // 1) REPEATERS BY AXLE  (this stays synchronous)
  // ==========================================================
  let unitRepeaters = [];

  if (unit.trailerNumber) {
    // Standalone trailer
    unitRepeaters = unit.repeaters.filter(
      r => parseInt(r.location.slice(-1)) === unit.trailerNumber
    );
  } else {
    // Truck or trailer under truck
    unitRepeaters = unit.repeaters.filter(
      r => parseInt(r.location.slice(-1)) === unitBox
    );
  }

  let axles = [];
  const config = unit.unitConfig.find(cfg => cfg.unitNumber === unitBox);

  if (config && Array.isArray(config.axles)) {
    axles = config.axles.map((_, index) => index);
  }

  // Render repeaters per axle
  for (let a = 0; a < axles.length; a++) {
    const unitBoxAxle = createUnitBoxAxle(
      unit.trailerNumber ? unit.trailerNumber : unitBox,
      unit,
      unitRepeaters,
      a + 1
    );
    repeaterDiagramUnitBox.appendChild(unitBoxAxle);
  }

  // ==========================================================
  // 2) SIGNAL BOOSTERS — ASYNC SECTION
  // ==========================================================

  // determine correct booster list
  let boosterIds = [];

  if (unit.type === 'trailer') {
    // standalone trailer
    boosterIds = unit.signalBoosterIds || [];
  }
  else if (unitBox === 0) {
    // truck
    boosterIds = unit.signalBoosterIds || [];
  }
  else {
    // trailer under truck
    const t = unit.trailers?.find(x => x.trailerNumber === unitBox);
    boosterIds = t?.signalBoosterIds || [];
  }

  // fetch & render boosters
  if (boosterIds.length > 0) {
    const boosterSection = await createSignalBoosterSection(unit, boosterIds);
    repeaterDiagramUnitBox.appendChild(boosterSection);
  }

  return repeaterDiagramUnitBox;
}

function createUnitBoxAxle(unitBox, unit, sensors, axle) {

  const unitBoxAxle = document.createElement('div');
  unitBoxAxle.className = 'diagramaxle';
  const sensorSuffix = `${addLeadingZero(axle)}${unitBox}`;
  const repeaterLeft = sensors.filter(s =>
    s.location.endsWith(sensorSuffix) && ["L"].includes(s.location.charAt(0))
  )[0];
  if (repeaterLeft) {
    let sensorLeft = createSensorElement(unit, repeaterLeft);
    unitBoxAxle.appendChild(sensorLeft);
  }

  const repeaterRight = sensors.filter(s =>
    s.location.endsWith(sensorSuffix) && ["R"].includes(s.location.charAt(0))
  )[0]; //** create empty if no repeater*/
  if (repeaterRight) {
    const sensorRight = createSensorElement(unit, repeaterRight);
    unitBoxAxle.appendChild(sensorRight);
  }

  return unitBoxAxle;
}

export const openSignalBoosterContextMenu = (unit, booster, event) => {

  const menu = document.getElementById('signalboostercontextmenu');
  const closeBtn = document.getElementById('closesignalboostermenu');

  menu.classList.add('show');
  closeBtn.style.display = "block";

  // small delay so DOM can measure
  setTimeout(() => {
    const rect = menu.getBoundingClientRect();
    const x = event.clientX - (rect.width / 2) - 10;
    const y = event.clientY;

    menu.style.left = `${x}px`;
    menu.style.top = `${y}px`;
    menu.style.position = 'absolute';
  }, 0);

  const closeMenu = () => {
    menu.classList.remove('show');
    closeBtn.style.display = "none";
  };

  closeBtn.addEventListener('click', () => closeMenu(), { once: true });

  menu.onclick = async function (e) {
    if (e.target.tagName !== 'LI') return;

    e.stopImmediatePropagation();
    closeMenu();

    switch (e.target.innerText.trim()) {

      case 'Signal Booster Report':
        document.body.style.cursor = 'none';
        document.getElementById("loadingBoxText").innerText = "Collecting Booster Data...";
        showLoading();

        // ⬅️ this must be your booster history endpoint (easy to plug in)
        const boosterData = await getSignalBoosterHistoryData(unit, booster);

        hideLoading();
        openLocationSensorReport(unit, boosterData);
        break;

      case 'General Information':
        openGeneralInfoForm('signalBooster', unit, booster);
        break;
    }
  };

  // click anywhere else closes menu
  document.addEventListener('click', function outside(e) {
    if (!menu.contains(e.target) && e.target !== closeBtn) {
      closeMenu();
    }
  }, { once: true });
};


function createBoosterElement(unit, booster) {
  const boosterDiv = document.createElement('div');
  boosterDiv.className = 'repeater';

  boosterDiv.appendChild(createSensorTopElement());

  const values = document.createElement('div');
  values.className = 'repeatersensorvalues';

  values.appendChild(createTimeUpdatedElement(booster.latestReceivedTS));
  values.appendChild(createRepeaterIdElement(booster.Id));

  if (booster.voltage > 0) {
    values.appendChild(createSensorVoltageElement(booster.voltage));
  } else {
    values.appendChild(createNoSignalElement());
  }

  boosterDiv.appendChild(values);
  boosterDiv.appendChild(createSensorBottomElement());

  boosterDiv.onclick = (e) => {
    e.stopImmediatePropagation();
    openSignalBoosterContextMenu(unit, booster, e);
  };

  return boosterDiv;
}


async function createSignalBoosterSection(unit, signalBoosterIds) {

  const signalBoosterSection = document.createElement('div');
  signalBoosterSection.className = "unitbox";

  // --- HEADER ---
  const header = document.createElement('h6');
  header.innerText = "Signal Boosters";
  //header.appendChild(hdiv);
  signalBoosterSection.appendChild(header);

  // --- BOOSTER LIST ---
  const boosterList = document.createElement('div');
  boosterList.className = "diagramaxle";

  // signalBoosterIds.forEach(id => {
  //     const booster = createSignalBoosterElement(id);
  //     boosterList.appendChild(booster);
  // });

  signalBoosterSection.appendChild(boosterList);

  const boosters = await loadBoosterData(unit, signalBoosterIds);

  boosters.forEach(booster => {
    const boosterElement = createBoosterElement(unit, booster);
    boosterList.appendChild(boosterElement);
  });

  return signalBoosterSection;
}

// function createSignalBoosterElement(boosterId) {
//     const booster = document.createElement('div');
//     booster.className = 'repeater';

//     //booster.appendChild(createSensorTopElement());

//     const values = document.createElement('div');
//     values.className = 'repeatersensorvalues';

//     values.appendChild(createRepeaterIdElement(boosterId));
//     //values.appendChild(createNoSignalElement()); // Boosters don’t have live data (right?)

//     booster.appendChild(values);
//     //booster.appendChild(createSensorBottomElement());

//     booster.onclick = (e) => {
//         e.stopImmediatePropagation();
//         openGeneralInfoForm('signalBooster', {}, { boosterId });
//     };

//     return booster;
// }


const createSensorElement = (unit, repeater) => {

  const sensor = document.createElement('div');
  sensor.id = `sensor${repeater.Id}`;
  sensor.className = 'repeater';
  sensor.appendChild(createSensorTopElement());
  sensor.appendChild(createSensorValuesElement(repeater));
  sensor.appendChild(createSensorBottomElement());

  sensor.onclick = (e) => {
    e.stopImmediatePropagation();
    openRepeaterContextMenu(unit, repeater, e);
    //openGeneralInfoForm('repeater', unit, repeater);
  };
  return sensor;
};

function createSensorTopElement() {

  const sensorTop = document.createElement('svg');
  sensorTop.className = 'repeaterimages repeatertop';
  return sensorTop;
}

function createSensorBottomElement() {

  const sensorBottom = document.createElement('svg');
  sensorBottom.className = 'repeaterimages repeaterbottom';
  return sensorBottom;
}

function createSensorValuesElement(axleSensor) {

  const sensorValues = document.createElement('div');
  sensorValues.className = 'repeatersensorvalues';

  const timestamp = axleSensor.latestReceivedTS;
  const recentTimestamp = timestamp && (new Date() - new Date(timestamp)) < 40 * 60 * 1000; // 40 minutes

  if (axleSensor) {
    sensorValues.appendChild(createTimeUpdatedElement(axleSensor.latestReceivedTS));
    sensorValues.appendChild(createRepeaterIdElement(axleSensor.repeaterId || axleSensor.Id));
    sensorValues.appendChild(createWheelConfigElement(axleSensor.wheelConfiguration || axleSensor.config?.wheel));
    if (recentTimestamp) {
      sensorValues.appendChild(createSensorVoltageElement(axleSensor.voltage));
    } else {
      sensorValues.appendChild(createNoSignalElement());
    }
  } else {
    sensorValues.appendChild(createNoSignalElement());
  }

  return sensorValues;
}

function createNoSignalElement() {

  const noSignal = document.createElement('div');
  noSignal.className = 'repeatersensorvaluesdefault wheelnosignal';
  noSignal.innerText = "No Signal";

  return noSignal;
}

function createRepeaterIdElement(repeaterId) {

  const repeaterIdDiv = document.createElement('div');
  repeaterIdDiv.className = 'repeatersensorvaluesdefault sensorid';
  repeaterIdDiv.innerText = repeaterId;

  return repeaterIdDiv;
}

function createTimeUpdatedElement(latestReceivedTS) {

  let repeaterTimeUpdatedDiv = document.createElement('div');
  repeaterTimeUpdatedDiv.className = 'repeatersensorvaluesdefault timeupdated';

  !latestReceivedTS ? repeaterTimeUpdatedDiv.innerText = '--:--:--' : repeaterTimeUpdatedDiv.innerText = formatTime(latestReceivedTS);

  return repeaterTimeUpdatedDiv;
}

function createWheelConfigElement(wheelConfig) {

  const wheelConfigDiv = document.createElement('div');
  let sensorValuesClasses = ['repeatersensorvaluesdefault'];

  wheelConfigDiv.classList.add(...sensorValuesClasses);
  wheelConfigDiv.innerText = wheelConfig;
  return wheelConfigDiv;
}

function createSensorVoltageElement(voltage) {

  const voltageDiv = document.createElement('div');

  let sensorValuesClasses = ['repeatersensorvaluesdefault'];

  if (voltage) {
    voltage = Math.round((voltage / 1000) * 100) / 100;
    if (voltage < 3.2)
      sensorValuesClasses = ['repeatersensorvaluesdefault', 'yellow'];

    voltageDiv.classList.add(...sensorValuesClasses);
    voltageDiv.innerText = voltage + " V";
  }

  return voltageDiv;
}

function createSignalStrengthElement(axleSensor) {

  const signalStrength = document.createElement('div');
  let sensorValuesClasses = ['repeatersensorvaluesdefault'];
  if (axleSensor.signalStrengthLabelColour === "blue")
    sensorValuesClasses = ['repeatersensorvaluesdefault', 'blue'];

  signalStrength.classList.add(...sensorValuesClasses);
  signalStrength.innerText = Math.round(axleSensor.signalStrength * 1000) / 1000 + " dBi";

  return signalStrength;
}

export const openRepeaterContextMenu = (unit, repeater, event) => {
  const repeaterContextMenu = document.getElementById('repeatercontextmenu');
  const closeRepeaterMenu = document.getElementById('closerepeatermenu');

  repeaterContextMenu.classList.add('show');
  closeRepeaterMenu.style.display = "block";

  //Wait a tick for DOM to render
  setTimeout(() => {
    const menuRect = repeaterContextMenu.getBoundingClientRect();
    const x = event.clientX - (menuRect.width / 2) - 10; // Shift center 10px left
    const y = event.clientY;

    // Position the menu
    repeaterContextMenu.style.left = `${x}px`;
    repeaterContextMenu.style.top = `${y}px`;
    repeaterContextMenu.style.position = 'absolute';
  }, 0);

  // Close function
  const closeMenu = () => {
    repeaterContextMenu.classList.remove('show');
    closeRepeaterMenu.style.display = "none";
  };

  closeRepeaterMenu.addEventListener('click', () => {
    closeMenu();
  }, { once: true });

  repeaterContextMenu.onclick = async function clickHandler(e) {
    if (e.target.tagName === 'LI') {
      e.stopImmediatePropagation();
      closeMenu();

      switch (e.target.innerText) {
        case 'Location Sensor Report':
          document.body.style.cursor = 'none';
          document.getElementById("loadingBoxText").innerText = "Collecting Report Data... ";
          showLoading();

          const repeaterData = await getRepeaterHistoryData(unit, repeater);

          hideLoading();
          openLocationSensorReport(unit, repeaterData);

          break;
        case 'General Information':
          openGeneralInfoForm('repeater', unit, repeater);
          break;
      }
    }
  };

  // Click anywhere else to close the menu
  document.addEventListener('click', function outsideClickListener(e) {
    if (!repeaterContextMenu.contains(e.target) && e.target !== closeRepeaterMenu) {
      closeMenu();
    }
  }, { once: true });
};

function createRepeaterDiagramButtons(unit) {

  let schematicDiagramButtonDivClasses = ['row', 'pane2buttons'];
  let schematicDiagramButtonDiv = document.createElement('div');
  schematicDiagramButtonDiv.classList.add(...schematicDiagramButtonDivClasses);

  let schematicDiagramButtonClasses = ['btn', 'btn-primary', 'panebutton', 'flex-child'];

  let notificationButtons = createNotificationButtons(unit);

  //notificationButtons.classList.add(...schematicDiagramButtonClasses);
  // let notificationButtons = document.createElement('button');
  // notificationButtons.type = 'button';
  // notificationButtons.title = 'SET NOTIFICATIONS';

  // const notificationsIcon = document.createElement('svg');
  // notificationsIcon.className = 'buttonicon notificationbluesvg';

  // const notificationsButtonText = document.createElement('span');
  // //wheelsDiagramButtonText.className = 'buttontext'; //class="buttontext buttontext-disabled"
  // notificationsButtonText.innerText = 'Notifications'; //'\xa0Unit'
  // notificationButtons.appendChild(notificationsIcon);
  // notificationButtons.appendChild(notificationsButtonText);

  // notificationButtons.onclick = function (e) {
  //     //openNotificationsForm(unit);
  //     e.stopImmediatePropagation();
  // };

  schematicDiagramButtonDiv.appendChild(notificationButtons);

  let repeaterDiagramButton = document.createElement('button');
  repeaterDiagramButton.classList.add(...schematicDiagramButtonClasses);
  repeaterDiagramButton.type = 'button';
  repeaterDiagramButton.title = 'VIEW WHEELS DIAGRAM';

  const tyreIcon = document.createElement('svg');
  tyreIcon.className = 'buttonicon tyrebluesvg';

  const repeaterDiagramButtonText = document.createElement('span');
  repeaterDiagramButtonText.innerText = 'Wheels Diagram';

  repeaterDiagramButton.appendChild(tyreIcon);
  repeaterDiagramButton.appendChild(repeaterDiagramButtonText);

  repeaterDiagramButton.onclick = function (e) {
    e.stopImmediatePropagation();
    createDiagramView(unit, 'WHEELSDIAGRAM', 'rightpane');
  };

  schematicDiagramButtonDiv.appendChild(repeaterDiagramButton);

  return schematicDiagramButtonDiv;
}

